// extracted by mini-css-extract-plugin
module.exports = {"article":"MediaArticleField_article__yyEeS"};